<template>
  <form @submit.prevent="save" lazy-validation>
    <v-dialog v-model="showModal" persistent scrollable max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Create contact</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field   
                    v-model="contact.name" label="Name"
                    v-validate="'required|max:75'"
                    :error-messages="errors.collect('name')"
                    data-vv-name="name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                    v-model="contact.email"
                    label="E-mail"
                    v-validate="'required|email'"
                    :error-messages="errors.collect('email')"
                    data-vv-name="email"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                    v-model="contact.position"
                    label="Segmentation 1"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                    v-model="contact.seniority"
                    label="Segmentation 2"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                    v-model="contact.priority"
                    label="Segmentation 3"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                    v-model="contact.company"
                    label="Segmentation 4"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                    v-model="contact.country"
                    label="Segmentation 5"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                    v-model="contact.segmentation"
                    label="Segmentation 6"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                    v-model="contact.segmentation2"
                    label="Segmentation 7"
                ></v-text-field>
              </v-flex>
               <v-flex xs12 sm6>
                <v-text-field
                    v-model="contact.tag"
                    label="Segmentation 8"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="open_modal = false">Cancel</v-btn>
          <v-btn color="primary" type="submit" @click="save">Save</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </form>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
  },
  data: () => {
    return {
      contact: {
        name: null,
        email: null,
        position: null,
        seniority: null,
        priority: null,
        country: null,
        segmentation: null,
        segmentation2: null,
        company: null,
        tag: null
      }
      
    };
  },
  computed: {

  },
  methods: {
    save () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.dispatch('setLoading', true);
          let payload = {
            name: this.name,
            email: this.email,
            position: this.position,
            seniority: this.seniority,
            priority: this.priority,
            country: this.country,
            segmentation: this.segmentation,
            segmentation2: this.segmentation2,
            company: this.company,
            tag: this.tag,
          };
          if (this.$store.state.contact.index_selected_contact >= 0) {
            payload.id = this.$store.state.contact.contact.id;
            let url = '/contacts/' + payload.id + '/update';
            window.axios.put(url, payload).then(response => {
              this.$store.dispatch('setSnackbar', {
                show: true,
                color: 'success',
                text: 'Contact updated.'
              });
              this.$store.dispatch('callEditContact', payload);
              this.$store.dispatch('setOpenModalCreateEdit', false);
              this.$store.dispatch('setLoading', false);
            })
              .catch(error => {
                this.$store.dispatch('setLoading', false);
              });
          } else {
            window.axios.post('/contacts/store', payload).then(response => {
              this.$store.dispatch('setSnackbar', {
                show: true,
                color: 'success',
                text: 'Contact saved.'
              });
              payload.id = response.data.data.id;
              this.$store.dispatch('callAddContact', payload);
              this.$store.dispatch('setOpenModalCreateEdit', false);
              this.$store.dispatch('setLoading', false);
            })
              .catch(error => {
                this.$store.dispatch('setLoading', false);
              });
          }
        } else {
          this.$store.dispatch('setSnackbar', {
            show: true,
            color: 'info',
            text: 'Check the form, please.'
          });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/client/contacts/components/modals/CreateContact.vue